export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const BAD_GATEWAY = 502;
export const INTERNAL_SERVER_ERROR = 500;
